module.exports = __webpack_public_path__ + "img/swt-logo2.761fb77a.png";